export default `
  query listWorkflowHistory($projectId: String!, $workflowId: String!, $limit: Int, $taggedOnly: Boolean, $nextToken: String) {
    listWorkflowHistory(projectId: $projectId, workflowId: $workflowId) {
      id
      email
      workflowHistory(workflowId: $workflowId, limit: $limit, taggedOnly: $taggedOnly, nextToken: $nextToken) {
        items {
          id
          version
          updatedAt
          tag
          updateNote {
            userRealName
            action
            target
          }
        }
        nextToken
      }
    }
  }
`
